module.exports = __webpack_public_path__ + "img/ic-youtube.1a524d17.svg";